import React from 'react'
import styled from 'styled-components'
import QuestionMarkIcon from './icons/question-mark'
import Tooltip from '../tooltip'

const ContainerElement = styled.span`
  position: relative;
  top: 2px;
`

function NotEditableIndicator({
  message = 'This field is not editable for default document buckets',
}) {
  return (
    <ContainerElement>
      <Tooltip text={message}>
        <QuestionMarkIcon />
      </Tooltip>
    </ContainerElement>
  )
}

export default NotEditableIndicator
